import { render } from "./PromotedProductsSlider.vue?vue&type=template&id=e1b27c4c"
import script from "./PromotedProductsSlider.vue?vue&type=script&lang=js"
export * from "./PromotedProductsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__